import { Flex, Skeleton, SkeletonText } from '@chakra-ui/react';
import React from 'react';

import './HeroSectionSkeletonNew.scss';

const HeroSectionSkeletonNew = () => {
  const themeButtonsSkeleton = Array(6)
    .fill(1)
    .map((_, i) => i + 1);

  return (
    <Flex className={'hero-section-skeleton-new-container'}>
      <Flex className={'title-and-description-skeleton-container'}>
        <SkeletonText
          noOfLines={1}
          skeletonHeight={5}
          className={'theme-buttons-section-topic-name'}
        />

        <SkeletonText
          noOfLines={2}
          skeletonHeight={10}
          className={'theme-buttons-section-title'}
        />
      </Flex>

      <SkeletonText
        noOfLines={1}
        skeletonHeight={6}
        className={'theme-buttons-section-description-skeleton'}
      />

      <Flex className={'theme-buttons-section-skeleton-container'}>
        {themeButtonsSkeleton.map(key => (
          <Flex className={'theme-button-skeleton-container'} key={key}>
            <Skeleton className={'theme-button-skeleton-image'} />

            <Flex className={'theme-button-text-skeleton-container'}>
              <SkeletonText
                noOfLines={3}
                skeletonHeight={2}
                className={'theme-button-skeleton-title'}
              />
            </Flex>
          </Flex>
        ))}
      </Flex>
    </Flex>
  );
};

export default HeroSectionSkeletonNew;
